<template>
  <div>
    <canvas ref="myChart"></canvas>
  </div>
</template>

<script>
export default {
  name: 'BarChartVertical',
  props: ['data', 'options'],
  data() {
    return {
      chartInstance: null,
    };
  },
  methods: {
    createChart() {
      if (typeof Chart === 'undefined') {
        console.error('Chart.js non è disponibile');
        return;
      }
      if (this.chartInstance) {
        this.chartInstance.destroy();
      }
      const ctx = this.$refs.myChart.getContext('2d');
      const defaultOptions = {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          x: {
            ticks: {
              autoSkip: false,
              maxRotation: 45,
              minRotation: 0,
            },
          },
          y: {
            beginAtZero: true,
          },
        },
      };
      this.chartInstance = new Chart(ctx, {
        type: 'bar',
        data: this.data,
        options: this.options || defaultOptions,
      });
    },
  },
  mounted() {
    this.createChart();
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/BarChartVertical.vue